/* eslint-disable */
import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_MENUDATA, SET_MENUDATA } from '../actions';
import { apiUrl, apiUrlV2, deliveryId } from "../components/Helpers/Config";
import Axios from 'axios';
import cookie from 'react-cookies';
import {reactLocalStorage} from 'reactjs-localstorage';

export const watchGetMenuData = function* () {
  yield takeEvery(GET_MENUDATA, workerGetMenuData);
}

function* workerGetMenuData({ menuslug, login_type}) {
  try {

    var app_id = "";
    if(login_type.login_type === "customer"){

      app_id = reactLocalStorage.get("app_id") !== "" &&  typeof reactLocalStorage.get("app_id") !== undefined &&  typeof reactLocalStorage.get("app_id") !== "undefined"  ? reactLocalStorage.get("app_id") : '';

    }else{

      app_id = cookie.load("merchant_app_id") !== "" && cookie.load("merchant_app_id") !== undefined && cookie.load("merchant_app_id") !== null
      ? cookie.load("merchant_app_id")
      : ''; 

    }

  const uri = apiUrl+'menu/menu?app_id='+app_id+'&menu_slug='+menuslug;
  const result = yield call(Axios.get, uri);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_MENUDATA, value: resultArr });
  } 
  catch {
    console.log('Get Menu Failed');
  }
} 
